import { render, staticRenderFns } from "./OpeningHourDisplay.vue?vue&type=template&id=7175351b&scoped=true"
import script from "./OpeningHourDisplay.vue?vue&type=script&lang=js"
export * from "./OpeningHourDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7175351b",
  null
  
)

export default component.exports